import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {customConfigurationFeatureKey, reducer} from './custom-configuration.reducer';
import {CustomConfigurationEffects} from './custom-configuration.effects';
import {TableCustomConfigurationComponent} from './table-custom-configuration/table-custom-configuration.component';
import {SharedModule} from '../shared.module';
import {
  ActiveTableCustomConfigurationComponent
} from './table-custom-configuration/active-table-custom-configuration/active-table-custom-configuration.component';
import {
  HierarchicalTableCustomConfigurationComponent
} from './table-custom-configuration/hierarchical-table-custom-configuration/hierarchical-table-custom-configuration.component';


@NgModule({
  declarations: [
    TableCustomConfigurationComponent,
    ActiveTableCustomConfigurationComponent,
    HierarchicalTableCustomConfigurationComponent
  ],
  exports: [
    ActiveTableCustomConfigurationComponent,
    HierarchicalTableCustomConfigurationComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(customConfigurationFeatureKey, reducer),
    EffectsModule.forFeature([CustomConfigurationEffects]),
    SharedModule,
  ]
})
export class CustomConfigurationModule {
}
